import { useTranslation, Trans } from 'onyx-common/i18n'

export {
  useTranslation,
  Trans
}
export default useTranslation
